import React, { useEffect, useRef, useState } from "react";
import usePDF from "../../hooks/flight/usePDF";
import { contructAccountStatementPDF } from "../../controllers/pdfController";
import AccountStatementPDFSection from "../pdf/AccountStatement/static/AccountStatementPDFSection";
import CommonDateSelectorInput from "../common/inputs/CommonDateSelectorInput";
import CommonDateRangeSelector from "../common/inputs/CommonDateRangeSelector";
import moment from "moment";
import { useTransactions } from "../../hooks/useTransactions";

function DownloadTransactionPDF() {
  const { handlePDFDownload } = usePDF();
  const { getAccountStatement } = useTransactions();
  const [downloading, setDownlaoding] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [range, setRange] = useState({
    startDate: moment().subtract(1, "month").startOf("month").toDate(),
    endDate: moment().toDate(),
  });
  const [data, setData] = useState(null);

  const pdfData = contructAccountStatementPDF(data);

  const pdfRef = useRef();

  const handleExportPDF = async () => {
    if (pdfRef?.current && !downloading) {
      let string = pdfRef.current.outerHTML;
      setDownlaoding(true);
      await handlePDFDownload(string, {
        fileName: "Transactions" || "",
      }).finally(() => setDownlaoding(false));
    }
  };

  const handleExport = async () => {
    await getAccountStatement({
      setLoading: setFetching,
      startDate: range?.startDate,
      endDate: range?.endDate,
      callback: (dt) => {
        setData(dt);
      },
    });
  };

  useEffect(() => {
    if (data) {
      handleExportPDF();
    }
  }, [data]);

  return (
    <div className="flex gap-2">
      <div className="hidden">
        <div className="" ref={pdfRef}>
          <AccountStatementPDFSection data={pdfData} />
        </div>
      </div>

      <div className="w-56">
        <CommonDateRangeSelector
          value={range}
          onChange={setRange}
          maxDate={new Date()}
        />
      </div>
      <button
        onClick={() => handleExport()}
        className="bg-primary1 h-12 w-32 rounded-md flex items-center justify-center text-sm text-white"
      >
        {downloading || fetching ? (
          <div className="buttonLoader" />
        ) : (
          <span>Export</span>
        )}
      </button>
    </div>
  );
}

export default DownloadTransactionPDF;
